import * as Sentry from '@sentry/browser';

export const sentryClient = new Sentry.BrowserClient({
  dsn: 'https://babbc547f0e340bf976c62283ef2d77b@sentry.wixpress.com/410',
});

export const captureException = (e: Error, isSite?: boolean) => {
  if (isSite) {
    sentryClient.captureException(e);
  }
};
